import { Component } from '@angular/core';
import { BaseInputComponent } from './base/base-input.component';
import { TranslateKeyPipe } from '../../../pipes/translate-key/translate-key.pipe';
import { CommonModule } from '@angular/common';
import { FormFieldErrorComponent } from '../form-field-error/form-field-error.component';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  imports: [
    TranslateKeyPipe,
    CommonModule,
    FormFieldErrorComponent,
    InputTextModule,
  ],
})
export class InputTextComponent extends BaseInputComponent {
  constructor() {
    super();
  }
}
